import { useMutation, useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useAppSelector } from 'src/services/redux/app/store';
import { useSelectedPeriod } from 'src/app/helpers/selected-period';

const REACT_APP_API_URL = `${process.env.REACT_APP_API_URL}`;

export interface IResultParams {
  results?: Array<any> | null | undefined | any;
  totalResults: number | null;
  totalPages: number | null;
  page?: number | null;
  limit?: number | null;
}
export interface IRequestParams {
  name?: string | null;
  identity?: number | null;
  page?: number | null | undefined;
  limit?: number | null;
  sortBy?: string | null;
  tabState?: any;
}
export const useRegistrationList = (params?: IRequestParams, onError?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  // Global sezon seçimi: seçili sezon varsa yalnızca o sezonun tarih aralığındaki kayıtlar listelenir
  const { periodId } = useSelectedPeriod();
  let requestParams: any = { ...params, id: user?.company_id };
  if (periodId !== null) requestParams.period_id = periodId;
  const requestUrl: any = REACT_APP_API_URL + requestParams.tabState.requestUrl;

  Object.keys(requestParams).map((params: any) => {
    if (typeof requestParams[params] !== 'object' && typeof requestParams[params] === 'string') requestParams[params] = requestParams[params]?.trim();
  });
  delete requestParams.tabState;
  const fetchData = async () => {
    const res = await axios.get<IResultParams>(`${requestUrl}`, { params: requestParams });
    return res?.data || {};
  };
  return useQuery(['registration-list', periodId], fetchData, {
    refetchOnWindowFocus: false,
    onError,
    enabled: false,
  });
};

export const useRegistrationDelete = (params?: any, onError?: any, onSuccess?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  const requestBody = { ...params, registration_sales_id: user?.company_id };
  const requestUrl = REACT_APP_API_URL + '/registration/delete';
  delete requestBody.name_lastname;
  delete requestBody.identity;
  const fetchData = async () => {
    const res = await axios.post(`${requestUrl}`, requestBody);
    return res?.data || {};
  };
  return useMutation(['registration-delete'], fetchData, {
    onError,
    onSuccess,
  });
};
export const useRegistrationCertainCreate = (onError?: any, onSuccess?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  const requestUrl = REACT_APP_API_URL + '/registration/certain/create';
  return useMutation(
    (formPayload: any) => {
      const requestBody = { ...formPayload, registration_sales_id: user?.company_id };
      return axios.post(`${requestUrl}`, requestBody);
    },
    { onError, onSuccess },
  );
};

export const useRegistrationCertainNewCreate = (onError?: any, onSuccess?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  const requestUrl = REACT_APP_API_URL + '/registration/certain/new/create';
  return useMutation(
    (formPayload: any) => {
      const requestBody = { ...formPayload, registration_application_id: user?.company_id };
      return axios.post(`${requestUrl}`, requestBody);
    },
    { onError, onSuccess },
  );
};

export const useRegistrationPreCreate = (onError?: any, onSuccess?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  const requestUrl = REACT_APP_API_URL + '/registration/pre/create';
  return useMutation(
    (formPayload: any) => {
      const requestBody = { ...formPayload, registration_application_id: user?.company_id };
      return axios.post(`${requestUrl}`, requestBody);
    },
    { onError, onSuccess },
  );
};

export const useClassList = (onError?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  const requestParams = { company_id: user?.company_id };
  const requestUrl = REACT_APP_API_URL + '/classes/list';
  const fetchData = async () => {
    const res = await axios.get(`${requestUrl}`, { params: requestParams });
    return res?.data || {};
  };
  return useQuery(['classes-list'], fetchData, {
    refetchOnWindowFocus: false,
    onError,
  });
};

export const useAreasList = (onError?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  const requestParams = { company_id: user?.company_id };
  const requestUrl = REACT_APP_API_URL + '/areas/list';
  const fetchData = async () => {
    const res = await axios.get(`${requestUrl}`, { params: requestParams });
    return res?.data || {};
  };
  return useQuery(['areas-list'], fetchData, {
    refetchOnWindowFocus: false,
    onError,
  });
};

export const useOrganisationTypeList = (onError?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  const requestParams = { company_id: user?.company_id };
  const requestUrl = REACT_APP_API_URL + '/organisation_type/list';
  const fetchData = async () => {
    const res = await axios.get(`${requestUrl}`, { params: requestParams });
    return res?.data || {};
  };
  return useQuery(['organisation_type-list'], fetchData, {
    refetchOnWindowFocus: false,
    onError,
  });
};

export const useClassBranchList = (onError?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  const requestParams = { company_id: user?.company_id };
  const requestUrl = REACT_APP_API_URL + '/classesBranch/list';
  const fetchData = async () => {
    const res = await axios.get(`${requestUrl}`, { params: requestParams });
    return res?.data || {};
  };
  return useQuery(['classesBranch-list'], fetchData, {
    refetchOnWindowFocus: false,
    onError,
  });
};
export const usePaymentMethod = (onError?: any) => {
  const requestUrl = REACT_APP_API_URL + '/paymentmethod/list';
  const fetchData = async () => {
    const res = await axios.get(`${requestUrl}`);
    return res?.data || {};
  };
  return useQuery(['paymentmethod-list'], fetchData, {
    refetchOnWindowFocus: false,
    onError,
  });
};
export const usePaymentInstallment = (onError?: any) => {
  const requestUrl = REACT_APP_API_URL + '/paymentinstallment/list';
  const fetchData = async () => {
    const res = await axios.get(`${requestUrl}`);
    return res?.data || {};
  };
  return useQuery(['paymentinstallment-list'], fetchData, {
    refetchOnWindowFocus: false,
    onError,
  });
};

export const useAgreement = (onError?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  const requestParams = { company_id: user?.company_id };
  const requestUrl = REACT_APP_API_URL + '/registration/agreement/list';

  const fetchData = async () => {
    const res = await axios.get(`${requestUrl}`, { params: requestParams });
    return res?.data || {};
  };
  return useQuery(['agreement-list'], fetchData, {
    refetchOnWindowFocus: false,
    onError,
  });
};

export const useSaveAgreement = (data?: any, onError?: any, onSuccess?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  const requestUrl = REACT_APP_API_URL + '/registration/agreement/create-update';
  return useMutation(
    (formPayload: any) => {
      const requestBody = { agreement: data, registration_agreement_id: user?.company_id };
      return axios.post(`${requestUrl}`, requestBody);
    },
    { onError, onSuccess },
  );
};

export const useRegistrationDetail = (student_id: any, onError?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  const requestParams = { company_id: user?.company_id, student_id };
  const requestUrl = REACT_APP_API_URL + '/registration/detail';
  const fetchData = async () => {
    const res = await axios.get(`${requestUrl}`, { params: requestParams });
    return res?.data || {};
  };
  return useQuery(['registration-detail'], fetchData, {
    refetchOnWindowFocus: false,
    onError,
  });
};

export const useStampUpload = (onError?: any, onSuccess?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  const requestUrl = REACT_APP_API_URL + '/company/stamp/create-update';
  return useMutation(
    (formPayload: any) => {
      const formData: any = new FormData();
      formData.append('stamp', formPayload?.stamp[0]);
      formData.append('company_id', user?.company_id);
      return axios.post(`${requestUrl}`, formData);
    },
    { onError, onSuccess },
  );
};

export const useStamplist = (onError?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  const requestParams = { company_id: user?.company_id };
  const requestUrl = REACT_APP_API_URL + '/company/stamp/list';
  const fetchData = async () => {
    const res = await axios.get(`${requestUrl}`, { params: requestParams });
    return res?.data;
  };
  return useQuery(['stamp-list'], fetchData, {
    refetchOnWindowFocus: false,
    onError,
  });
};

export const useStampDelete = (onError?: any, onSuccess?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  const requestUrl = REACT_APP_API_URL + '/company/stamp/delete';
  return useMutation(
    (formPayload: any) => {
      const payload = { company_id: user?.company_id };
      return axios.post(`${requestUrl}`, payload);
    },
    { onError, onSuccess },
  );
};
export const useUserCreate = (onError?: any, onSuccess?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  const requestUrl = REACT_APP_API_URL + '/registration/user/create';
  return useMutation(
    (formPayload: any) => {
      const payload = { ...formPayload, registration_application_id: user?.company_id };
      return axios.post(`${requestUrl}`, payload);
    },
    { onError, onSuccess },
  );
};

export const useUserDelete = (onError?: any, onSuccess?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  const requestUrl = REACT_APP_API_URL + '/registration/user/delete';
  return useMutation(
    (formPayload: any) => {
      const payload = { ...formPayload, registration_application_id: user?.company_id };
      return axios.post(`${requestUrl}`, payload);
    },
    { onError, onSuccess },
  );
};

export const useExamList = (params?: IRequestParams, onError?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  const requestParams = { ...params, id: user?.company_id };
  const requestUrl = REACT_APP_API_URL + '/exam/list';
  const fetchData = async () => {
    const res = await axios.get<IResultParams>(`${requestUrl}`, { params: requestParams });
    return res?.data || {};
  };
  return useQuery(['exam-list'], fetchData, {
    refetchOnWindowFocus: false,
    onError,
  });
};

export const useExamDelete = (onError?: any, onSuccess?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  const requestUrl = REACT_APP_API_URL + '/exam/delete';
  return useMutation(
    (formPayload: any) => {
      const requestBody = { ...formPayload, exam_application_id: user?.company_id };
      return axios.post(`${requestUrl}`, requestBody);
    },
    { onError, onSuccess },
  );
};

export const useExamSessionsList = (params?: IRequestParams, onError?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  const requestParams = { ...params, id: user?.company_id };
  const requestUrl = REACT_APP_API_URL + '/examsessions/list';
  const fetchData = async () => {
    const res = await axios.get<IResultParams>(`${requestUrl}`, { params: requestParams });
    return res?.data || {};
  };
  return useQuery(['examsessions-list'], fetchData, {
    refetchOnWindowFocus: false,
    onError,
  });
};

export const useExamSessionsDelete = (onError?: any, onSuccess?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  const requestUrl = REACT_APP_API_URL + '/examsessions/delete';
  return useMutation(
    (formPayload: any) => {
      const requestBody = { ...formPayload, exam_session_id: user?.company_id };
      return axios.post(`${requestUrl}`, requestBody);
    },
    { onError, onSuccess },
  );
};

export const useExamSessionsCreate = (onError?: any, onSuccess?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  const requestUrl = REACT_APP_API_URL + '/examsessions/create';
  return useMutation(
    (formPayload: any) => {
      const requestBody = { ...formPayload, exam_session_id: user?.company_id };
      return axios.post(`${requestUrl}`, requestBody);
    },
    { onError, onSuccess },
  );
};

export const useExamSessionsUpdate = (onError?: any, onSuccess?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  const requestUrl = REACT_APP_API_URL + '/examsessions/update';
  return useMutation(
    (formPayload: any) => {
      const requestBody = { ...formPayload, exam_session_id: user?.company_id };
      return axios.post(`${requestUrl}`, requestBody);
    },
    { onError, onSuccess },
  );
};

export const usePeriodsList = (onError?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  const requestParams = { company_id: user?.company_id };
  const requestUrl = REACT_APP_API_URL + '/periods/list';
  const fetchData = async () => {
    const res: any = await axios.get<IResultParams>(`${requestUrl}`, { params: requestParams });
    return res?.data || {};
  };
  return useQuery(['periods-list'], fetchData, {
    refetchOnWindowFocus: false,
    onError,
  });
};

export const useCreateEmail = (onError?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  const requestUrl = REACT_APP_API_URL + '/registration/user/generate-email';
  return useMutation(
    (formPayload: any) => {
      const requestBody = { ...formPayload, registration_application_id: user?.company_id };
      return axios.post(`${requestUrl}`, requestBody);
    },
    { onError },
  );
};

export const useNotificationPermission = (onError?: any, onSuccess?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  const requestUrl = REACT_APP_API_URL + '/registration/notification-permission/update';
  return useMutation(
    (formPayload: any) => {
      const requestBody = { ...formPayload, company_id: user?.company_id };
      return axios.post(`${requestUrl}`, requestBody);
    },
    { onError, onSuccess },
  );
};

export const useBanksList = (onError?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  const requestParams = { company_id: user?.company_id };
  const requestUrl = REACT_APP_API_URL + '/banks/list';
  const fetchData = async () => {
    const res = await axios.get(`${requestUrl}`, { params: requestParams });
    return res?.data || {};
  };
  return useQuery(['banks-list'], fetchData, {
    refetchOnWindowFocus: false,
    onError,
  });
};

export const useCashesList = (onError?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  const requestParams = { company_id: user?.company_id };
  const requestUrl = REACT_APP_API_URL + '/cashes/list';
  const fetchData = async () => {
    const res = await axios.get(`${requestUrl}`, { params: requestParams });
    return res?.data || {};
  };
  return useQuery(['cashes-list'], fetchData, {
    refetchOnWindowFocus: false,
    onError,
  });
};

export const useExportRegistration = (onError?: any, onSuccess?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  return useMutation(
    async (formPayload: any) => {
      const requestUrl = REACT_APP_API_URL + '/registration/export';
      const res = await axios.post(`${requestUrl}`, { ...formPayload, tabState: formPayload.tabState, company_id: user?.company_id }, { responseType: 'blob' });
      const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      window.open(url, '_blank');
      return res;
    },
    { onError, onSuccess },
  );
};

export const useFileManager = (filters: any, onError?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  const requestParams = { company_id: user?.company_id, ...filters };
  const requestUrl = REACT_APP_API_URL + '/file-manager/list';
  const fetchData = async () => {
    const res = await axios.get(`${requestUrl}`, { params: requestParams });
    return res?.data || {};
  };
  return useQuery(['file-manager-list'], fetchData, {
    refetchOnWindowFocus: false,
    enabled: false,
    onError,
  });
};

export const useFileFolderCreate = (onError?: any, onSuccess?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  const requestUrl = REACT_APP_API_URL + '/file-manager/create';
  return useMutation(
    (formPayload: any) => {
      const payload = { ...formPayload, company_id: user?.company_id };
      return axios.post(`${requestUrl}`, payload);
    },
    { onError, onSuccess },
  );
};

export const useFilesCreate = (onError?: any, onSuccess?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  const requestUrl = `${process.env.REACT_APP_API_URL}/file-manager/files-create`;

  return useMutation(
    async (formPayload: any) => {
      const payload = { ...formPayload, company_id: user?.company_id };

      const formData = new FormData();

      // Append documents to FormData
      if (formPayload?.document) {
        Array.from(formPayload.document).forEach((file: any) => {
          formData.append('documents', file); // Note: 'documents' is used here, should match your server-side expectation
        });
      }

      // Append other fields
      formData.append('company_id', payload.company_id);
      formData.append('student_id', payload.student_id);
      formData.append('directory', payload.directory || '');

      // Send the request
      return axios.post(requestUrl, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    },
    { onError, onSuccess },
  );
};

export const useFilesDelete = (onError?: any, onSuccess?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  const requestUrl = REACT_APP_API_URL + '/file-manager/files-delete';
  return useMutation(
    (formPayload: any) => {
      const payload = { ...formPayload, company_id: user?.company_id };
      return axios.post(`${requestUrl}`, payload);
    },
    { onError, onSuccess },
  );
};

export const useNotesList = (id: any, onError?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  const requestParams = { company_id: user?.company_id, student_id: id };
  const requestUrl = REACT_APP_API_URL + '/registration/notes/list';
  const fetchData = async () => {
    const res = await axios.get(`${requestUrl}`, { params: requestParams });
    return res?.data || {};
  };
  return useQuery(['use-registration-notes-list'], fetchData, {
    refetchOnWindowFocus: false,
    enabled: true,
    onError,
  });
};

export const useNotesCreate = (onError?: any, onSuccess?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  const requestUrl = REACT_APP_API_URL + '/registration/notes/create';
  return useMutation(
    (formPayload: any) => {
      const requestBody = { ...formPayload, company_id: user?.company_id };
      return axios.post(`${requestUrl}`, requestBody);
    },
    { onError, onSuccess },
  );
};

export const useNotesUpdate = (onError?: any, onSuccess?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  const requestUrl = REACT_APP_API_URL + '/registration/notes/update';
  return useMutation(
    (formPayload: any) => {
      const requestBody = { ...formPayload, company_id: user?.company_id };
      return axios.post(`${requestUrl}`, requestBody);
    },
    { onError, onSuccess },
  );
};

export const useNotesDelete = (onError?: any, onSuccess?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  const requestUrl = REACT_APP_API_URL + '/registration/notes/delete';
  return useMutation(
    (formPayload: any) => {
      const requestBody = { ...formPayload, company_id: user?.company_id };
      return axios.post(`${requestUrl}`, requestBody);
    },
    { onError, onSuccess },
  );
};

export const usePaymentsList = (id: any, onError?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  const requestParams = { company_id: user?.company_id, student_id: id };
  const requestUrl = REACT_APP_API_URL + '/registration/payments/list';
  const fetchData = async () => {
    const res = await axios.get(`${requestUrl}`, { params: requestParams });
    return res?.data || {};
  };
  return useQuery(['use-registration-payments-list'], fetchData, {
    refetchOnWindowFocus: false,
    enabled: true,
    onError,
  });
};

export const useChangeBranches = (onError?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  const requestParams = { company_id: user?.company_id };
  const requestUrl = REACT_APP_API_URL + '/branches/change/list';
  const fetchData = async () => {
    const res = await axios.get(`${requestUrl}`, { params: requestParams });
    return res?.data || {};
  };
  return useQuery(['change-branches-list'], fetchData, {
    refetchOnWindowFocus: false,
    onError,
    enabled: false,
  });
};

export const useChangeClassBranches = (params: any, onError?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  const requestParams = { ...params, company_id: params?.branch_id };
  const requestUrl = REACT_APP_API_URL + '/branches/class/list';
  const fetchData = async () => {
    const res = await axios.get(`${requestUrl}`, { params: requestParams });
    return res?.data || {};
  };
  return useQuery(['change-branches-class-list'], fetchData, {
    refetchOnWindowFocus: false,
    onError,
    enabled: false,
  });
};

export const useChangeBranchBranches = (params: any, onError?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  const requestParams = { ...params, company_id: params?.branch_id };
  const requestUrl = REACT_APP_API_URL + '/branches/branch/list';
  const fetchData = async () => {
    const res = await axios.get(`${requestUrl}`, { params: requestParams });
    return res?.data || {};
  };
  return useQuery(['change-branches-branch-list'], fetchData, {
    refetchOnWindowFocus: false,
    onError,
    enabled: false,
  });
};

export const useChangePeriodBranches = (params: any, onError?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  const requestParams = { ...params, company_id: params?.branch_id };
  const requestUrl = REACT_APP_API_URL + '/branches/period/list';
  const fetchData = async () => {
    const res = await axios.get(`${requestUrl}`, { params: requestParams });
    return res?.data || {};
  };
  return useQuery(['change-branches-period-list'], fetchData, {
    refetchOnWindowFocus: false,
    onError,
    enabled: false,
  });
};

export const useBranchesChangeUpdate = (onError?: any, onSuccess?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  const requestUrl = REACT_APP_API_URL + '/branches/change/update';
  return useMutation(
    (formPayload: any) => {
      const requestBody = { ...formPayload, company_id: user?.company_id };
      return axios.post(`${requestUrl}`, requestBody);
    },
    { onError, onSuccess },
  );
};
